import React from 'react';
import { BuildingIcon, MegaphoneIcon, ScaleIcon, ShieldIcon } from 'lucide-react';
import { pillars } from '../data/profile';
const ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  operations: BuildingIcon,
  defense: ShieldIcon,
  policy: ScaleIcon,
  crisis: MegaphoneIcon
};
export function StrategicPillars() {
  return <section className="bg-offwhite py-16 lg:py-24" data-id="element-252" data-mp="393n92j2431t4">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-253" data-mp="msf5t3akrr6">
        <div className="grid gap-10 lg:grid-cols-12 lg:gap-16" data-id="element-254" data-mp="4nb7do93jztw">
          <div className="lg:col-span-5" data-id="element-255" data-mp="4msztvgzhz6o">
            <h2 className="font-serif text-3xl leading-tight text-navy sm:text-4xl" data-id="element-256" data-mp="3n1k43b0x305o">
              Four decades of decision authority where the stakes were national.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-charcoal" data-id="element-257" data-mp="3ry27o7kigsgf">
              Rear Admiral (Ret.) Gregory J. Slavonic has led at the operational
              center of the Department of the Navy, in the senior staff of both
              chambers of Congress, at the head of statewide agencies, and in the
              boardrooms of regulated enterprises. His practice is the same in each:
              clarify the mission, stabilize the operation, and hold the institution
              to its standard.
            </p>
            <p className="mt-4 text-base leading-relaxed text-charcoal" data-id="element-258" data-mp="33lmzmrspqb0i">
              Founder and CEO of Blue-Water Strategies, he advises boards and
              executives on governance, crisis communications and public-sector
              strategy.
            </p>
          </div>

          <div className="grid gap-px bg-mist sm:grid-cols-2 lg:col-span-7" data-id="element-259" data-mp="3rb7nnp3q3ygn">
            {pillars.map(pillar => {
            const Icon = ICONS[pillar.id];
            return <article key={pillar.id} className="flex flex-col bg-white p-7" data-id="element-260" data-mp="1wxgawgq3kygz">
                  <Icon className="h-6 w-6 text-gold-deep" aria-hidden="true" data-id="element-261" data-mp="1rzeu62g59b8o" />
                  <h3 className="mt-5 font-serif text-xl leading-snug text-navy" data-id="element-262" data-mp="3s14m89dfipdl">
                    {pillar.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-charcoal" data-id="element-263" data-mp="utqmsr6ugtn">
                    {pillar.description}
                  </p>
                  <ul className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-264" data-mp="9v02ybb5har8">
                    {pillar.proof.map(item => <li key={item} className="border border-mist px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide text-slate-500" data-id="element-265" data-mp="euutgdr0jybr">
                        {item}
                      </li>)}
                  </ul>
                </article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}